import {Observable} from 'rxjs';
import {AbstractStorageUnitDialogsManagerService, NewStorageUnitDialogResult} from '|shared';
import {inject, Injectable} from '@angular/core';
import {
  NewStorageUnitDialogComponent,
} from '../components/new-storage-unit-dialog/new-storage-unit-dialog.component';
import {
  StorageUnitInsertDialogComponent,
  StorageUnitInsertDialogData
} from '../components/storage-unit-insert-dialog/storage-unit-insert-dialog.component';
import {StorageUnitDto} from '|api/document';
import {IczModalService, IczModalSizeClass} from '@icz/angular-modal';

@Injectable()
export class StorageUnitDialogsManagerService implements AbstractStorageUnitDialogsManagerService {

  private modalService = inject(IczModalService);

  openStorageUnitCreateDialog() {
    return this.modalService.openComponentInModal<NewStorageUnitDialogResult, void>({
      component: NewStorageUnitDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_RESPONSIVE,
        titleTemplate: 'Nová ukládací jednotka',
        disableAutoMargin: true,
      },
    });
  }

  openStorageUnitInsertDialog(storageUnit: StorageUnitDto): Observable<boolean> {
    return this.modalService.openComponentInModal<boolean, StorageUnitInsertDialogData>({
      component: StorageUnitInsertDialogComponent,
      modalOptions: {
        sizeClass: IczModalSizeClass.WH_RESPONSIVE,
        titleTemplate: 'Vložení do {{storageUnitNumber}} - {{storageUnitName}}',
        titleTemplateContext: {
          storageUnitNumber: storageUnit.storageUnitNumber,
          storageUnitName: storageUnit.name,
        },
        disableAutoMargin: true,
      },
      data: {
        storageUnitId: storageUnit.id!,
        isMove: false,
      }
    });
  }

}
